export default __webpack_public_path__ + "./ico-registered.562a87c336bfacac52f3c6bc43e468cc.png";